module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Thanks to Ken and Phyllis Reeves, who own Patchwork Plus. They have given me many teaching opportunities to test my patterns in classes. They have also given me a flexible schedule.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("It has been a delight to work with the staff members at C&T Publishing. Without their help, I could never have written this book. Their good ideas and expertise have been invaluable.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Another thanks to the generosity of fabric companies: P&B Textiles, RJR Fabrics, and Michael Miller Fabrics.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("I also want to thank Joyce Horst for helping in writing “My Quilting Journey.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e249c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9781607054221_04_ack.vue
// module id = 63
// module chunks = 0